"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultRenderValue = exports.DefaultRenderValueWithIcon = void 0;

var React = _interopRequireWildcard(require("react"));

var _Box = require("grommet/components/Box");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tag = require("./Tag");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ValueNodeStyling = _styledComponents.default.div.withConfig({
  displayName: "ValueNodeStyling",
  componentId: "lpuzhd-0"
})(["border-radius:5px;padding-left:0.6em;padding-bottom:0.6em;svg{font-size:1.5em;position:relative;top:0.3em;left:-0.2em;}"]);

var DefaultRenderValueWithIcon = function DefaultRenderValueWithIcon(i) {
  return function (value, updateValue) {
    var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var removeValue = function removeValue(v) {
      return function () {
        return updateValue({
          value: value.filter(function (o) {
            return o.value !== v;
          })
        });
      };
    };

    return value.length > 0 && React.createElement(_Box.Box, {
      direction: "row",
      wrap: true
    }, React.createElement(ValueNodeStyling, null, i), value.map(function (v) {
      return React.createElement(_Tag.Tag, {
        key: v.value,
        value: v.value,
        label: v.label,
        remove: removeValue(v.value),
        disabled: disabled
      });
    }));
  };
};

exports.DefaultRenderValueWithIcon = DefaultRenderValueWithIcon;

var DefaultRenderValue = function DefaultRenderValue(value, updateValue) {
  var disabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var removeValue = function removeValue(v) {
    return function () {
      return updateValue({
        value: value.filter(function (o) {
          return o.value !== v;
        })
      });
    };
  };

  return value.length > 0 && React.createElement(_Box.Box, {
    direction: "row",
    wrap: true
  }, value.map(function (v) {
    return React.createElement(_Tag.Tag, {
      key: v.value,
      value: v.value,
      label: v.label,
      remove: removeValue(v.value),
      disabled: disabled
    });
  }));
};

exports.DefaultRenderValue = DefaultRenderValue;